// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.status-text {
  font-size: 0.9rem;
}

.checkbox-text-error {
  color: #f44336;
}

.radio-text-error {
  color: #f44336;
}

mat-radio-button {
  padding-right: 16px;
}

.caretaker_slider {
  letter-spacing: 0.5px;
  margin-bottom: 0.55rem;
  font-weight: 500;
}

.constraints_border {
  border-bottom: 2px #eee solid;
  margin-bottom: 0.5rem;
}

mat-form-field.mt-0 {
  margin-top: 0 !important;
}
mat-form-field.mt-0 ::ng-deep .mat-form-field-wrapper {
  padding-top: 0;
}

mat-form-field.status-select ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0;
  margin-bottom: 3px;
}
mat-form-field.status-select ::ng-deep .mat-form-field-infix {
  padding: 0.5em 0 0.5em 0;
  border-top-width: 0.5em;
}
mat-form-field.status-select ::ng-deep .mat-select {
  font-size: 0.85rem;
}
mat-form-field.status-select ::ng-deep .mat-form-field-outline {
  top: 0.5em;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/user-add/user-add.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,sBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,6BAAA;EACA,qBAAA;AAAJ;;AAIA;EACI,wBAAA;AADJ;AAGI;EACI,cAAA;AADR;;AAUQ;EACI,iBAAA;EACA,kBAAA;AAPZ;AAUQ;EACI,wBAAA;EACA,uBAAA;AARZ;AAWQ;EACI,kBAAA;AATZ;AAYQ;EACI,UAAA;AAVZ","sourcesContent":[".status-circle {\r\n    border-radius: 50%;\r\n    width: 10px;\r\n    height: 10px;\r\n}\r\n\r\n.status-text {\r\n    font-size: 0.9rem;\r\n    // color: #adb5bd;\r\n}\r\n\r\n.checkbox-text-error {\r\n    color: #f44336;\r\n}\r\n\r\n.radio-text-error {\r\n    color: #f44336;\r\n}\r\n\r\nmat-radio-button {\r\n    padding-right: 16px;\r\n}\r\n\r\n.caretaker_slider {\r\n    letter-spacing: .5px;\r\n    margin-bottom: 0.55rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.constraints_border {\r\n    border-bottom: 2px #eee solid;\r\n    margin-bottom: .5rem;\r\n}\r\n\r\n\r\nmat-form-field.mt-0 {\r\n    margin-top: 0 !important;\r\n\r\n    ::ng-deep .mat-form-field-wrapper {\r\n        padding-top: 0;\r\n    }\r\n}\r\n\r\n\r\nmat-form-field.status-select {\r\n    \r\n\r\n    ::ng-deep {\r\n        .mat-form-field-wrapper {\r\n            padding-bottom: 0;\r\n            margin-bottom: 3px;\r\n        }\r\n\r\n        .mat-form-field-infix {\r\n            padding: 0.5em 0 0.5em 0; // Top και bottom padding\r\n            border-top-width: 0.5em;\r\n        }\r\n\r\n        .mat-select {\r\n            font-size: 0.85rem;\r\n        }\r\n\r\n        .mat-form-field-outline {\r\n            top: 0.5em; // Μικρότερο outline\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
